import { FC, useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import NFTCard from "../../components/NFTCard";
import "../../assets/scss/common.scss";
import "./Trending.scss";
import ReactGA from "react-ga4";
import ApiService from "../../services/ApiService";
import { TrendingCollectionListClass } from "../../utils/HelperClass/CommonClass";

export const TrendingPage: FC = (props: any) => {
	const [TrendingCollection, setTrendingCollection] = useState<
		TrendingCollectionListClass[]
	>([]);

	useEffect(() => {
		async function getTrendingCollection() {
			const LandingSlider = await ApiService.GetTrendingNFTCollection(50);
			setTrendingCollection(LandingSlider);
		}
		getTrendingCollection();
	}, []);

	return (
		<>
			<Header />
			<main className="main-content">
				<div className="inner-content">
					<section className="landing-main-wrapper">
						<Container>
							<Row>
								<h1 className="page-title">
									Collect Latest <span className="art-text">Web3.0</span> Based
									Collections
								</h1>
								{TrendingCollection.length > 0 ? (
									TrendingCollection.map((hero, i) => {
										let item = { ...hero, page: "Trending-Page" };
										return (
											<NFTCard
												key={i}
												index={i}
												item={item}
												isTrending
											></NFTCard>
										);
									})
								) : (
									<Row>
										<h1 className="loading">Loading ...</h1>
									</Row>
								)}
							</Row>
						</Container>
					</section>
				</div>
				<Footer></Footer>
			</main>
		</>
	);
};

export default TrendingPage;
